export const colors = [
    {
        name: 'indigo',
        medium: 'bg-indigo-500',
        mediumText: 'text-indigo-500',
        light: 'bg-indigo-300',
        dark: 'bg-indigo-700',
    },
    {
        name: 'red',
        medium: 'bg-red-500',
        mediumText: 'text-red-500',
        light: 'bg-red-300',
        dark: 'bg-red-700',
    },
    {
        name: 'lime',
        medium: 'bg-lime-500',
        mediumText: 'text-lime-500',
        light: 'bg-lime-300',
        dark: 'bg-lime-700',
    },
    {
        name: 'teal',
        medium: 'bg-teal-500',
        mediumText: 'text-teal-500',
        light: 'bg-teal-300',
        dark: 'bg-teal-700',
    },
    {
        name: 'blue',
        medium: 'bg-blue-500',
        mediumText: 'text-blue-500',
        light: 'bg-blue-300',
        dark: 'bg-blue-700',
    },
    {
        name: 'purple',
        medium: 'bg-purple-500',
        mediumText: 'text-purple-500',
        light: 'bg-purple-300',
        dark: 'bg-purple-700',
    },
    {
        name: 'yellow',
        medium: 'bg-yellow-500',
        mediumText: 'text-yellow-500',
        light: 'bg-yellow-300',
        dark: 'bg-yellow-700',
    },
];
